<template>
  <div style="width: 100%">
    <div class="row mb-2">
      <div class="form-group col-12">
        <label for="client">{{ $t("client") }}</label>
        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="arenaClients"
          :getOptionLabel="(client) => `${client.CLI_ID} - ${client.CLI_DSC}`"
          v-model="clientSelected"
          :reduce="(client) => client.CLI_ID"
        />
      </div>
    </div>

    <div class="row mb-2">
      <button
        class="btn btn-primary form-group ml-3"
        @click="openModalShowStructure"
      >
        Ver estrutura &nbsp; <i class="fas fa-eye"></i>
      </button>

      <button
        class="btn btn-primary form-group ml-3"
        @click="openModalAddCustomDeliveryDetail"
        v-if="clientSelected"
      >
        Adicionar propriedade &nbsp; <i class="fas fa-plus"></i>
      </button>
    </div>

    <div class="row mb-5" v-if="clientSelected">
      <div class="col-12">
        <table class="table table-striped">
          <thead class="">
            <tr>
              <th scope="col">Path</th>
              <th scope="col">Format</th>
              <th scope="col">Prefix</th>
              <th scope="col">Suffix</th>
              <th scope="col"></th>
            </tr>
          </thead>

          <draggable v-model="deliveryDetails" tag="tbody">
            <tr v-for="(item, index) in deliveryDetails" :key="index">
              <td>{{ item.path }}</td>
              <td>{{ item.format }}</td>
              <td>{{ item.prefix }}</td>
              <td>{{ item.suffix }}</td>
              <td>
                <button
                  class="btn btn-danger btn-sm btn-circle"
                  @click="removeDeliveryDetail(item.path)"
                >
                  <i class="fas fa-trash" />
                </button>
              </td>
            </tr>
          </draggable>
        </table>
      </div>

      <LoaderButton
        class="ml-3"
        @click="save"
        :loading="isLoading"
      >
        {{ $t("save") }}
      </LoaderButton>
    </div>

    <!-- MODAL ADD CUSTOM DELIVERY DETAIL -->
    <div
      class="modal fade"
      id="modalAddCustomDeliveryDetail"
      tabindex="-1"
      role="dialog"
      aria-labelledby="titleModal"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" id="titleModal">Adicionar</h4>

            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Fechar"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <form
              id="osForm"
              class="mx-auto col-sm-8 col-lg-12"
              @submit.prevent
            >
              <div class="row">
                <div class="form-group col-lg-12">
                  <label for="property">{{ $t("property") }}</label>
                  <Combobox
                    class="bg-white"
                    name="property"
                    :placeholder="$t('select_a_item')"
                    :options="paths"
                    :initial-value="path"
                    v-model="path"
                    label="name"
                    :reduce="(path) => path.value"
                  />
                </div>

                <div class="form-group col-lg-12">
                  <label for="formats">{{ $t("formats") }}</label>
                  <Combobox
                    class="bg-white"
                    name="formats"
                    :placeholder="$t('select_a_item')"
                    :options="formats"
                    :initial-value="format"
                    label="name"
                    v-model="format"
                    :reduce="(format) => format.value"
                  />
                </div>

                <div class="form-group col-lg-12">
                  <label for="prefix">{{ $t("prefix") }}</label>
                  <input
                    type="text"
                    id="prefix"
                    name="prefix"
                    class="form-control"
                    :placeholder="$t('ph_prefix')"
                    v-model="prefix"
                  />
                </div>

                <div class="form-group col-lg-12">
                  <label for="suffix">{{ $t("suffix") }}</label>
                  <input
                    type="text"
                    id="suffix"
                    name="suffix"
                    class="form-control"
                    :placeholder="$t('ph_suffix')"
                    v-model="suffix"
                  />
                </div>
              </div>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>

            <button
              type="button"
              class="btn btn-primary"
              @click="addDeliveryDetail"
            >
              {{ $t("create") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL SHOW BODY INFO -->
    <div
      class="modal fade"
      id="modalShowStructure"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalShowStructureLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalShowStructureLabel">Estrutura</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <textarea
              name=""
              id="jsonStructure"
              cols="30"
              rows="20"
              style="width: 100%"
            />
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              {{ $t("close") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import draggable from "vuedraggable";
import { mapState } from "vuex";
import { paths, formats, structure } from "@/config/custom-delivery-details";

export default {
  name: "CustomDeliveryDetailsForm",
  components: {
    LoaderButton,
    Combobox,
    draggable,
  },

  data() {
    return {
      clientSelected: undefined,
      prefix: "",
      suffix: "",
      format: "",
      path: "",
      paths,
      formats,
    };
  },

  watch: {
    clientSelected(value) {
      if (!value) {
        this.deliveryDetails = [];

        return;
      }

      this.deliveryDetails = [];

      this.fetchCustomDeliveryDetails();
    },
  },

  computed: {
    ...mapState({
      arenaClients: (state) => state.arena.clients,
      isLoading: (state) => state.integrator.isLoading,
    }),

    deliveryDetails: {
      get() {
        return this.$store.state.integrator.customDeliveryDetails;
      },

      set(value) {
        this.$store.commit("integrator/setCustomDeliveryDetails", value);
      },
    },
  },

  methods: {
    async fetchClients() {
      await this.$store.dispatch("arena/fetchClients");
    },

    async fetchCustomDeliveryDetails() {
      await this.$store.dispatch(
        "integrator/fetchCustomDeliveryDetails",
        this.clientSelected
      );
    },

    openModalAddCustomDeliveryDetail() {
      $("#modalAddCustomDeliveryDetail").modal("show");
    },

    closeModalAddCustomDeliveryDetail() {
      $("#modalAddCustomDeliveryDetail").modal("hide");
    },

    showToast(message, type = "success") {
      this.$store.dispatch(
        "toast/showToast",
        { message, type },
        { root: true }
      );
    },

    addDeliveryDetail() {
      try {
        if (!this.path) {
          this.showToast("Informe pelo menos uma Propriedade", "error");

          return;
        }

        const alreadyExists = this.deliveryDetails.find(
          (item) => item.path === this.path
        );

        if (alreadyExists) {
          this.showToast("Propriedade já cadastrada", "error");

          return;
        }

        const newDeliveryDetails = [
          ...this.deliveryDetails,
          {
            path: this.path,
            format: this.format,
            prefix: this.prefix,
            suffix: this.suffix,
          },
        ];

        this.deliveryDetails = newDeliveryDetails;

        this.path = "";
        this.format = "";
        this.prefix = "";
        this.suffix = "";

        this.closeModalAddCustomDeliveryDetail()
      } catch (error) {
        this.showToast(JSON.stringify(error), "error");
      }
    },

    removeDeliveryDetail(path) {
      const newDeliveryDetails = this.deliveryDetails.filter(
        (item) => item.path !== path
      );

      this.deliveryDetails = newDeliveryDetails;
    },

    openModalShowStructure() {
      $("#modalShowStructure").modal("show");
    },

    async save() {
      const save = await this.$store.dispatch("integrator/saveCustomDeliveryDetails", {
        id: this.clientSelected,
        deliveryDetails: this.deliveryDetails,
      });

      if (save) {
        this.showToast("Configurações alteradas com sucesso!");
      }
    },
  },

  mounted() {
    this.fetchClients();

    const json = JSON.stringify(structure, undefined, 4);

    $("#jsonStructure").text(json);
  },
};
</script>
